import React from "react";
import NextImage from "../common/NextImage";

const SummaryBox = ({ title, score, data }) => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  return (
    <div className="summary_box">
      <div className="summary_box_head">
        <strong className="title">{title}</strong>
        <span className="points">{score}</span>
      </div>
      <ul className="incident_summary">
        {data?.length ? (
          data?.map((item, index) => (
            <li
              key={item?.ty + index}
              className={item?.isH === 0 ? "reverse" : ""}
            >
              <span className="mints">{item?.mins}&apos;</span>
              <span className="icon_wrp">
                {item?.ty === "MISSED" ? (
                  <NextImage
                    src={`${baseURL}/public/assets/images/error.png`}
                    width={17}
                    height={18}
                    alt="icon"
                  />
                ) : (
                  <NextImage
                    src={`${baseURL}/public/assets/images/${
                      item?.ty === "Goal"
                        ? "icehockey.svg"
                        : item?.ty === "SUB"
                        ? "changer.png"
                        : "union.png"
                    }`}
                    width={17}
                    height={18}
                    alt="icon"
                  />
                )}
              </span>
              <span className="name">{item?.pl?.name}</span>
              <span className="subName">{item?.ty}</span>
            </li>
          ))
        ) : (
          <li>No Goal</li>
        )}
      </ul>
    </div>
  );
};

export default SummaryBox;
